// the javascript must be included from the recurly website
// as well as the Config.js that includes the public key
export default window.recurly;
export const publicKey = window.Config.Recurly.public_key;
